import { CalendarDays } from "lucide-react";
import { fmtUSD } from "@/lib/money";

const MONTHS = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"];

export const MonthlySpendCard = ({ balance }) => {
  const monthName = MONTHS[new Date().getMonth()];
  return (
    <div className="border border-border bg-[#0A0A0A] rounded-sm p-6" data-testid="monthly-spend-card">
      <div className="flex items-center gap-2 text-muted-foreground mb-2">
        <CalendarDays className="w-4 h-4" />
        <span className="text-[10px] uppercase tracking-[0.25em] font-bold">{monthName} call spend</span>
      </div>
      <p className="font-mono text-4xl font-bold" data-testid="monthly-spend-amount">
        {balance === null ? "…" : fmtUSD(balance.month_spend || 0)}
      </p>
      {balance !== null && (
        <p className="text-xs text-muted-foreground mt-2" data-testid="monthly-spend-detail">
          {balance.month_calls > 0
            ? `${balance.month_calls} call${balance.month_calls === 1 ? "" : "s"} · ${balance.month_minutes} min billed this month`
            : "No paid-line calls yet this month."}
        </p>
      )}
    </div>
  );
};
